export default "__VITE_ASSET__97f9d8cd__"